import Vue from 'vue';
import helpers from '../../utils/helpers';

export default (id, params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`/warehouses/products/${id}/search`, params))
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/search.js